// 3D terrain palette — pure rendering data (colours only), no game logic.
// Values mirror the 2.5D painter palette so the world reads the same in either
// renderer. THREE.Color takes 0..1 linear-ish sRGB; we feed hex and let three
// convert. Owner: client-render3d.

import { Color } from 'three'
import { Terrain } from '../../shared/terrain'

/** Base top-face colour per terrain type — a touch sunnier/saturated than the 2.5D
 *  painter so the lit 3D world reads cheerful rather than washed. */
export const TERRAIN_COLOR: Record<Terrain, Color> = {
  [Terrain.DeepWater]: new Color('#17406b'),
  [Terrain.Water]: new Color('#2e72a4'),
  [Terrain.Sand]: new Color('#e3cd90'),
  [Terrain.Grass]: new Color('#83ba55'),
  [Terrain.Fertile]: new Color('#66ad4f'),
  [Terrain.Forest]: new Color('#4d8442'),
  [Terrain.Hills]: new Color('#a89f70'),
  [Terrain.Mountain]: new Color('#8a8591'),
  [Terrain.Swamp]: new Color('#5d7048'),
  [Terrain.Snow]: new Color('#e6ecf1'),
}

/** Warm chocolate soil for hex side-walls — mostly earth, with a whisper of the
 *  tile's own colour so snowfields don't sit on the same dirt as grassland. */
export function cliffColor(top: Color): Color {
  return new Color('#6f4f31').lerp(top, 0.12)
}

export function isWaterTerrain(t: Terrain): boolean {
  return t === Terrain.Water || t === Terrain.DeepWater
}
